const PaymentMethod = {
  FleetCard: "fleet-card",
  FleetCardManualPO: "fleet-card-manual-po",
  FuelCode: "fuel-code",
  PLBLocqpayManualPOCredit: "plb-locqpay-manual-po-credit",
};

export default PaymentMethod;
